<template>
  <div class="bottom-bar">
    <div
      v-if="!ReplayliveState && webinarInfo.replaySwitch !== 1"
      class="count-down-container"
      v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
    >
      <span class="circle-tips"></span>
      <span class="time-prefix">{{ webinarStatusTitle }}</span>
      <van-count-down
        :time="allTime"
        @finish="finish"
        @change="changeCountDown"
        v-show="this.webinarStatusTitle !== '会议已经结束'"
        v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
      >
        <template v-slot="timeData">
          <span
            class="vcd-unit"
            v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
            >{{ timeData.days }}</span
          >
          天
          <span
            class="vcd-unit"
            v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
            >{{ timeData.hours }}</span
          >
          时
          <span
            class="vcd-unit"
            v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
            >{{ timeData.minutes }}</span
          >
          分
          <span
            class="vcd-unit"
            v-bind:style="{ color: template.meetingInfo.countdown.color.value }"
            >{{ timeData.seconds }}</span
          >
          秒
        </template>
      </van-count-down>
    </div>
    <div
      v-if="webinarInfo.replaySwitch !== 1 && !ReplayliveState"
      @click="joinBtnClick"
      class="sign-up-btn"
      v-bind:style="{
        color: template.meetingInfo.btn_join.color.value,
        backgroundColor: template.meetingInfo.btn_join.backgroundColor.value
      }"
    >
      {{
        template.meetingInfo.btn_join.text.value == "立即参会"
          ? signUpTextStatus || "立即参会"
          : template.meetingInfo.btn_join.text.value
      }}
    </div>
    <div
      v-if="webinarInfo.replaySwitch == 1 && !ReplayliveState"
      @click="joinBtnClick"
      class="sign-up-btn-replay"
      v-bind:style="{
        color: template.meetingInfo.btn_join.color.value,
        backgroundColor: template.meetingInfo.btn_join.backgroundColor.value
      }"
    >
      {{
        template.meetingInfo.btn_join.text.value == "立即参会"
          ? signUpTextStatus || "立即参会"
          : template.meetingInfo.btn_join.text.value
      }}
    </div>
    <div
      v-if="ReplayliveState"
      class="sign-up-btn-replay"
      v-bind:style="{
        color: template.meetingInfo.btn_join.color.value,
        backgroundColor: template.meetingInfo.btn_join.backgroundColor.value
      }"
    >
      直播回放
    </div>
  </div>
</template>

<script>
import { $subscriber, URLS } from "fire-wind-water";
import { validateState } from "@/common/joinMeeting";
import { mixinsTemplate } from "../../common/mixinsTemplate";
export default {
  name: "BottomBar",
  mixins: [mixinsTemplate],
  data() {
    return {
      webinarInfo: {},
      userInfo: {},
      allTime: "",
      webinarStatusTitle: "",
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 &&
        window.location.href.indexOf("isSetting=1") > -1
          ? true
          : false, //静态链接回放状态
      signUpTextStatus: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
      });
      $subscriber.subscribe("signUpTextStatus", data => {
        this.signUpTextStatus = data;
      });
      $subscriber.subscribe("onCountdown", () => {
        this.countdown();
      });
    },
    async joinBtnClick() {
      let info = window.$sk.webinar.get().meetingInfo;
      let webinarInfo = Object.assign(this.webinarInfo, info);
      let userInfo = Object.assign(
        this.userInfo,
        window.$sk.webinar.get().user
      );
      //验证用户状态  审核中 未通过 无权限  会议已经关闭 会场未发布
      if (window.$sk.webinar.get().canJoin(webinarInfo, userInfo)) {
        if (window.$sk.webinar.get().canEnter(webinarInfo, userInfo)) {
          //可进入会场
          window.location.href = window.location.href.replace(
            "/meetingInfo",
            "/meeting"
          );
        } else {
          let returnUrl = window.location.href;
          if (!webinarInfo.isClosed) {
            returnUrl = window.location.href.replace(
              "/meetingInfo",
              "/meeting"
            );
          }
          if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needLogin &&
            !userInfo.isLogin &&
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needRegistration &&
            !userInfo.isRegistration
          ) {
            window.$sk.goto(
              webinarInfo.loginUrl +
                "sourceKey=" +
                URLS.getURL("sourceKey") +
                "&backUrl=" +
                encodeURIComponent(webinarInfo.goToSignUpUrl)
            );
          } else if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needLogin &&
            !userInfo.isLogin
          ) {
            window.$sk.goto(
              webinarInfo.loginUrl +
                "sourceKey=" +
                URLS.getURL("sourceKey") +
                "&backUrl=" +
                encodeURIComponent(returnUrl)
            );
          } else if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needRegistration &&
            !userInfo.isRegistration
          ) {
            window.$sk.goto(webinarInfo.goToSignUpUrl);
          } else {
            window.$sk.goto(returnUrl);
          }
        }
      } else {
        if (this.webinarInfo.isOnDemand) {
          window.location.href = webinarInfo.demandUrl;
        } else {
          validateState(webinarInfo, userInfo);
        }
      }
    },
    //计算时间
    countdown() {
      if (this.webinarInfo.serverTime < this.webinarInfo.startTime) {
        this.webinarStatusTitle = "距离会议开始还有"; //未开始
        this.allTime = this.webinarInfo.startTime - this.webinarInfo.serverTime;
      } else if (
        this.webinarInfo.startTime <= this.webinarInfo.serverTime &&
        this.webinarInfo.serverTime < this.webinarInfo.endTime
      ) {
        this.webinarStatusTitle = "距离会议结束还有"; //进行中
        this.allTime = this.webinarInfo.endTime - this.webinarInfo.serverTime;
      } else {
        this.webinarStatusTitle = "会议已经结束"; //已结束
      }
    },
    finish() {
      ///监听倒计时结束时间
      this.countdown();
    },
    ///倒计时开始发生变化
    changeCountDown() {
      this.webinarInfo.serverTime += 1000;
    }
  }
};
</script>
<style scoped lang="scss"></style>
